<!-- ============================================================== -->
<!-- Main wrapper - style you can find in pages.scss -->
<!-- ============================================================== -->
<!-- <router-outlet>
    <app-spinner></app-spinner>
</router-outlet> -->
<!--  -->
<app-spinner/>
<router-outlet>
    
</router-outlet>
<!-- <button (click)="submitForm()">Submit</button> -->